import ApiBase from './ApiBase'

export default class ApiCollection extends ApiBase {

	constructor () {
		super()
		this.data = []
	}

	toSelectOptions () {
		const options = []
		this.data.forEach(element => {
			const value = element.id || ''
			const text = element.name || ''
			options.push({ value, text })
		})
		return options
	}

	toSelectOptionsGrouped () {
		const groups = []
		this.data.forEach(element => {
			const options = []
			element.elements.forEach(subelement => {
				const value = subelement.id || ''
				const text = subelement.name || ''
				options.push({ value, text })
			})
			groups.push({
				label: element.name,
				options
			})
		})
		return groups
	}
}



// WEBPACK FOOTER //
// ./src/classes/api/ApiCollection.js